import { cancelAutopayFamily } from 'reactApp/appHelpers/featuresHelpers/features/cancelAutopayFamily';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { isFamilyEmpty, isUserFamilyMember, isUserFamilyOwner } from 'reactApp/modules/family/family.selectors';
import type { CheckOffer, OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import {
    closeCancelAutoRenewFamilyModal,
    renderCancelAutoRenewFamilyModal,
} from 'reactApp/ui/CancelAutoRenewFamilyModal/CancelAutoRenewFamilyModal.helpers';
import { select } from 'typed-redux-saga';

// tempexp_17359-start
export function* checkFamilyOffer(_: CheckOffer) {
    const isOverquota = yield* select(UserQuotaSelectors.isOverquota);
    const isFamilyMember = yield* select(isUserFamilyMember);
    const isFamilyOwner = yield* select(isUserFamilyOwner);
    const subscriptionsCount = yield* select(BillingDataSelectors.getSubscriptionsCount);
    const isEmptyFamily = yield* select(isFamilyEmpty);
    return (
        cancelAutopayFamily &&
        !isFamilyMember &&
        ((!isOverquota && !isFamilyMember && !isFamilyOwner) ||
            (isFamilyOwner && !isEmptyFamily && subscriptionsCount === 1) ||
            (isFamilyOwner && isEmptyFamily))
    );
}
// tempexp_17359-end

export function* familyOffer({ subscription, continueOutflow, cancelOutflow }: OutflowOfferWebProps) {
    yield renderCancelAutoRenewFamilyModal({
        subscription,
        onCancel() {
            closeCancelAutoRenewFamilyModal();
            continueOutflow();
        },
        onClose() {
            closeCancelAutoRenewFamilyModal();
            cancelOutflow();
        },

        onSuccess() {
            closeCancelAutoRenewFamilyModal();
            cancelOutflow();
        },
    });
}
